module.exports = __webpack_public_path__ + "static/guitar-hero-2-5206a99039682e55754228605c63a1d7.jpg";